import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgThumbsUpMid = function SvgThumbsUpMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.611 4C11.5162 4 11.4299 4.05326 11.3876 4.13539L7.5 11.6818V20H17.422C18.5339 20 19.4791 19.1878 19.6463 18.0885L20.4833 12.5885C20.6906 11.2267 19.6364 10 18.2589 10H13.0161C12.797 10 12.5889 9.9042 12.4464 9.73777C12.3039 9.57135 12.2413 9.35094 12.2751 9.13446L12.8507 5.44256C12.9685 4.68697 12.3805 4 11.611 4ZM6 20V12H3.75C3.61192 12 3.5 12.1119 3.5 12.25V19.75C3.5 19.8881 3.61192 20 3.75 20H6ZM6.42149 10.5H3.75C2.78352 10.5 2 11.2835 2 12.25V19.75C2 20.7165 2.78352 21.5 3.75 21.5H17.422C19.2752 21.5 20.8505 20.1463 21.1293 18.3141C21.1293 18.3141 21.1293 18.3141 21.1293 18.3141L21.9663 12.8141C22.3116 10.5445 20.5548 8.5 18.2589 8.5H13.8921L14.3327 5.67365C14.3327 5.67364 14.3327 5.67365 14.3327 5.67365C14.5931 4.00375 13.2963 2.5 11.611 2.5C10.9568 2.5 10.3546 2.86505 10.0541 3.44857C10.0541 3.44861 10.0541 3.44853 10.0541 3.44857L6.42149 10.5Z"
  })));
};

export { SvgThumbsUpMid as ReactComponent };
//# sourceMappingURL=thumbs-up-mid.svg.js.map
